import { gql } from '@apollo/client';

export const GET_FILES_RELATIONSHIP = gql`
    query findDataSetRelation($input : FindDataSetRelationInput) {
        findDataSetRelation(input : $input) {
            projectId
            fileMatchPercentage
            sourceFileName
            targetFileName
            operation
            sourceCol
            targetCol
            sourceGroupByCol
            targetGroupByCol
            columnMatch
            sourceFileDisplayName
            targetFileDisplayName
        }
    }
`;

export const GET_LATER = '';
